import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { NAV_BAR_WIDTH_AT_LARGE } from '@navigation/layouts/SideBar';
import { MSG_TYPE_ERROR, MSG_TYPE_SUCCESS, MSG_TYPE_INFO } from '../../constants/messageTypes';
import AnalyticsPixel from '../AnalyticsPixel';
// import Slide from '@material-ui/core/Slide';

/*
//TODO:
img
width (% o px?)
efecto?
Pasar a archivo de constantes
*/
const TIMEOUT_DEFAULT = 5000;

const SnackBarModal = (props) => {
  const {
    open,
    title,
    handleClose,
    distanceBottom,
    type = MSG_TYPE_ERROR,
    button,
    id /*= true */,
    analyticsId,
    data,
    existNavBar,
    margin = '16px 24px 0px 24px',
  } = props;

  const JUSTIFY_PERFECT_CONTENT = 16;
  const marginLeftOfMiddleOfNavMenu = existNavBar
    ? NAV_BAR_WIDTH_AT_LARGE - JUSTIFY_PERFECT_CONTENT
    : 0;

  useEffect(() => {
    setTimeout(() => {
      if (button === undefined) handleClose();
    }, TIMEOUT_DEFAULT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const useStyles = makeStyles((theme) => ({
    info: {
      // backgroundColor: "#a0d894",
      // color: "#213e22",
    },
    success: {
      backgroundColor: '#a0d894',
      color: '#213e22',
    },
    error: {
      backgroundColor: '#f9c3bf',
      color: '#7D150F',
    },
    info: {
      backgroundColor: '#C0DBF3',
      color: '#003366',
    },
    paper: {
      borderRadius: 4,
      testAlign: 'left',
      position: 'absolute',
      zIndex: 10,
      margin,
      [theme.breakpoints.only('xs')]: {
        boxShadow: 'none',
        padding: '17px 16px',
        transform: 'none',
        borderRadius: '6px',
        margin: '8px 16px',
      },
      [theme.breakpoints.up('sm')]: {
        boxShadow: theme.shadows[5],
        padding: '17px 16px',
      },
    },
    button: {
      float: 'right',
      marginLeft: 10,
      cursor: 'pointer',
    },
    show: {
      [theme.breakpoints.only('xs')]: {
        top: '0px',
      },
    },
    hide: {
      top: `${!distanceBottom ? '-100px' : 'inherit'}`,
      bottom: `${distanceBottom ? '-100px' : 'inherit'}`,
    },
    parent: {
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.up('lg')]: {
        marginLeft: marginLeftOfMiddleOfNavMenu,
      },
      whiteSpace: 'pre-line',
    },
  }));
  const classes = useStyles();

  return (
    <div className={classes.parent}>
      <div
        className={`
                  ${open ? classes.show : classes.hide} 
                  ${type === MSG_TYPE_ERROR ? classes.error : ''} 
                  ${type === MSG_TYPE_SUCCESS ? classes.success : ''} 
                  ${type === MSG_TYPE_INFO ? classes.info : ''} 
                  ${classes.paper} 
              `}
        id={id}
        data={data}
      >
        {title}
        {button ? (
          <span id="span-snack-bar" className={classes.button} onClick={() => handleClose()}>
            X
          </span>
        ) : (
          ''
        )}
        {open && <AnalyticsPixel type={type} id={analyticsId} />}
      </div>
    </div>
  );
};

SnackBarModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
};
export default SnackBarModal;
